import React, { useContext } from 'react'

import LineHeartClickIcon from 'components/Luxkit/Icons/line/LineHeartClickIcon'
import PromotionLabel from 'components/Luxkit/Label/PromotionLabel'
import TripContext from 'tripPlanner/contexts/TripContext'
import { useTrip } from 'tripPlanner/hooks/api/trip'

function SuggestedLabel() {
  const tripContext = useContext(TripContext)

  const { data: trip } = useTrip({ tripId: tripContext?.tripId })

  const tripHasChildren = !!trip?.travellerRooms?.some(room => room.childAges.length > 0)

  return (
    <PromotionLabel
      variant="engagement"
      icon={<LineHeartClickIcon />}
    >
      {tripHasChildren ? 'Recommended for families' : 'Recommended for you'}
    </PromotionLabel>
  )
}

export default SuggestedLabel
